const ITEMS = [
  "JUSQU'À -50 %",
  "LES GRANDES MARQUES, LES PETITS PRIX",
  "100 % AUTHENTIQUE",
  "BELLE, SANS EXPLOSER TON BUDGET",
  "LE LUXE DEVIENT ACCESSIBLE",
];

export default function Marquee({ dark = false }) {
  const row = [...ITEMS, ...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className={`overflow-hidden border-y py-4 select-none ${
        dark ? "bg-kay-ink text-kay-rose border-white/10" : "bg-white/60 text-kay-ink/70 border-kay-line"
      }`}
    >
      <div className="animate-marquee flex w-max items-center gap-10 whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-10">
            {row.map((t, i) => (
              <span key={i} className="flex items-center gap-10 font-mono text-xs tracking-[0.3em] uppercase">
                {t}
                <span className="text-kay-pink">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
